import React from "react";
import { getSimpleFormattedDate } from "../../../utils/utils";
import EmailSender from "../../common/EmailSender/EmailSender";

const combineChildrenHeaders = (children) => {
  return children.map((child) => {
    const { id, label, type } = child;
    return { key: id, label: label, type: type || "string" };
  });
};

const generateHeaders = (columns) => {
  return columns.flatMap((column) => {
    if (column?.children) {
      return combineChildrenHeaders(column.children);
    } else {
      const { id, label, type } = column;
      return { key: id, label: label, type: type || "string" };
    }
  });
};

const HRKRIReportingAnalyticsEmail = ({
  columns,
  datas,
  selectedMonthEnd,
  hedgeRatioPercentage,
  disabled = true,
} = {}) => {
  const headers = generateHeaders(columns);

  const tableData = datas.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });
  return (
    <EmailSender
      sheets={[
        {
          name: "HR_KRI_Reporting",
          header: headers,
          data: tableData,
          showHeader: true,
        },
      ]}
      disabled={disabled}
      fileName={`HRKRIReportingAnalytics_${getSimpleFormattedDate()}.xlsx`}
      includeAttachments={false} // Include attachements only if its true
      subject="GTWA Notification - Hedge Ratio KRI Reporting File"
      templateName="file-received"
      variable={{
        monthEnd: selectedMonthEnd?.format("MMM YYYY"),
        hedgeRatioPercentage: `${hedgeRatioPercentage}%`,
      }}
    />
  );
};

export default HRKRIReportingAnalyticsEmail;
